import { FC } from "react";
import { useDispatch } from "react-redux";

import { UserAddressForm } from "Bands/components";
import { createUserAddress, dispatchGetUserAddresses } from "Bands/state";
import { USER_ACTIONS } from "Bands/types";
import { copy } from "shared/assets";
import { IFormButtons, IPlace } from "shared/types";
import { UserEntityModal } from "Bands/containers";
import { Marker } from "shared/assets/icons";

const { userAddress: addressCopy } = copy;

interface Props {
  handleClose: () => void;
}

export const CreateUserAddressModal: FC<Props> = ({ handleClose }) => {
  const dispatch = useDispatch();

  const buttons: IFormButtons = {
    primary: {
      children: addressCopy.buttons.create,
    },
    secondary: {
      onClick: handleClose,
    },
  };

  const handleSubmit = (data: IPlace) => {
    dispatch(createUserAddress(data));
  };

  const handleSuccess = () => {
    dispatchGetUserAddresses(dispatch);
  };

  return (
    <UserEntityModal
      title={addressCopy.create.title}
      icon={Marker}
      action={USER_ACTIONS.createUserAddress}
      buttons={buttons}
      successMessage={addressCopy.messages.created}
      Component={UserAddressForm}
      handleSubmit={handleSubmit}
      handleClose={handleClose}
      handleSuccess={handleSuccess}
    />
  );
};
